<!--
 * @Author: Tang Yuxuan
 * @Date: 2020-10-12 11:00:51
 * @LastEditTime: 2020-10-28 19:08:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\errorCorrection.vue
-->
<!-- 论文纠错 -->
<template>
<div class="errorCorrection">
    <button class="back" @click="back()"><img src="/static/images/nav_return_default.png" alt="" srcset=""> 返回</button>
    <div class="title_row">
        <span class="left_span"><span class="shu"></span>查重记录</span>
    </div>
    <div class="non404" v-if="checklistData.total==0">
        <div>
            <img class="userimg" src="/static/images/non404_xiangsiyuan.png" alt="" srcset="" />
            <p>该篇论文还未进行过查重</p>
            <button class="btn_err" @click="get_check">立即查重</button>
        </div>
    </div>

    <div class="list" v-if="checklistData.total>0">
        <div class="list_row" v-for="(item,index) in checklistData.records" :key="index">
            <div class="title_h3"><span>{{item.title}}</span>
                <div class="icon_box" v-if="item.checkState==3"><span class="dowbg" @click="open(item.reportUrl)"></span> <span class="dow" @click="open(item.downloadUrl)"></span> </div>
            </div>
            <div class="time"><img src="/static/images/chachong_shijianbiao.png" alt="" srcset=""> {{item.createTime}}</div>
            <div class="error_type">
                <div class="type"><img src="/static/images/chachong_jianchezhong.png" alt="" srcset="">{{status[item.checkState-0]}}</div>
                <div>重复率： <span class="red">{{item.similar||'-'}}%</span></div>
            </div>
        </div>
    </div>
    <div class="flooter" v-if="checklistData.total>0">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"></el-pagination> 共1页
    </div>
</div>
</template>

<script>
export default {
    props: ['checklistData'],
    data: function () {
        return {
            yanUrl: '/static/images/chachong_eye_default.png',
            dowUrl: '/static/images/chachong_download_default.png',
            listData: [{}],
            status: ['待提交', '待检测', '检测中', '检测完成', '检测失败'],
            pages: {
                current: 1,
                size: 10
            },
            total: 0
        };
    },
    components: {},
    mounted: function () {},
    methods: {
        /**
         * 下载或预览
         */
        open: function (url) {
            window.open(url, '_blank').location;
        },
        back: function () {
            this.$emit('backlist', 'false')
            // this.$emit('backlists', 'false')
        },
        get_check: function () {

            this.$emit('get_check', 'false')
        },
        handleCurrentChange: function (val) {
            console.log(`当前页: ${val}`);
            this.pages.current = val
            this.$emit('golist', val)
        }
    }
};
</script>

<style lang="scss" scoped>
.errorCorrection {
    width: calc(100% - 80px);
    padding: 0 40px;

    .back {
        background: none;
        border: none;
        margin-top: 20px;
    }

    .title_row {
        color: $btnc;
        display: flex;
        justify-content: space-between;
        padding: 20px 0;

        .left_span {
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: bold;

            .shu {
                border-left: 4px solid $btnc;
                height: 18px;
                display: inline-block;
                margin-right: 12px;
            }
        }

        .h_btn {
            color: #ffffff;
            border: none;
            background: linear-gradient(0deg, #8A8A8A 0%, #A8A8A8 100%);
            padding: 0 10px;
            border-radius: 20px;
            font-size: 14px;
            height: 28px;
        }

        .h_btn:hover {
            background: linear-gradient(0deg, #5676BD 0%, #7395DE 100%);

        }
    }

    .flooter {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .non404 {
        text-align: center;
        margin-top: 168px;

        img {
            width: 111px;
            height: 111px;
        }

        p {
            margin-top: 38px;
            font-size: 14px;
            color: #989EA2;
            line-height: 22px;
        }

        .btn_err {
            color: $btnc;
            background: none;
            border: none;
            margin-top: 24px;
        }
    }

    .list {
        height: calc(100vh - 250px);
        overflow: auto;
        padding-right: 16px;
    }

    .list_row+.list_row {
        margin-top: 16px;
    }

    .list_row {

        border: 1px solid #EEEEEE;
        border-radius: 4px;
        padding: 16px 20px;

        .title_h3 {
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 16px;
                font-weight: bold;
                color: #34343A;
            }

            .icon_box {
                display: flex;
                align-items: center;

                img {
                    height: 12px;
                    margin-left: 10px;
                }
            }
        }

        .time {
            display: flex;
            align-items: center;
            color: #989EA2;
            margin-top: 12px;

            img {
                width: 14px;
                height: 14px;
                margin-right: 8px;
            }
        }

        .error_type {
            display: flex;
            justify-content: space-between;
            margin-top: 24px;

            .type {
                display: flex;
                align-items: center;

                img {
                    margin-right: 8px;
                }
            }

            .red {
                color: #FF5A5A;
                font-size: 16px;
            }
        }
    }

    .dowbg {
        display: inline-block;
        width: 16px;
        height: 12px;
        background: url('/static/images/chachong_eye_default.png');
    }

    .dowbg:hover {
        background: url('/static/images/chachong_eye_hover.png');
    }

    .dow {
        display: inline-block;
        width: 16px;
        height: 12px;
        background: url('/static/images/chachong_download_default.png') no-repeat;
        background-size: 14px 11px;
        margin-left: 8px;
    }

    .dow:hover {
        background: url('/static/images/chachong_download_hover.png') no-repeat;
        background-size: 14px 11px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/duplicate.vue